export default __webpack_public_path__ + "static/media/shapes-slab.87e8eaca.png";